export default function Heading({ content, variant = "default", title }) {
  const isFirst = variant === "first"
  const displayText = title || content;

  return (
    <div className="inline-flex items-stretch gap-0">
      <div
        className={`${
          isFirst ? "bg-white" : "bg-[var(--color-primary)]"
        } w-[6px] flex-shrink-0 self-stretch rounded-full`}
      ></div>
          <h2
            className={`font-semibold leading-[1.3] font-[Noto Sans] m-0 px-3 align-middle text-xl md:text-2xl lg:text-3xl ${
              isFirst ? "text-white" : "text-[#212121]"
            }`}
            style={{
              transform: 'scale(var(--app-title-scale, 1))',
              transformOrigin: 'left center'
            }}
          >
            {displayText}
          </h2>
    </div>
  )
}
